import React from 'react';
import './PatientList.css';

const PatientList = ({ patients, loading, onPatientSelect, onRefresh }) => {
    const formatDate = (dateString) => {
        if (!dateString) return 'Never';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    const getProgressColor = (progress) => {
        if (progress >= 80) return '#27ae60';
        if (progress >= 50) return '#f39c12';
        if (progress >= 25) return '#e67e22';
        return '#e74c3c';
    };

    const getStatusBadge = (patient) => {
        const hasRecentActivity = patient.lastJournalEntry &&
            new Date(patient.lastJournalEntry) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

        if (hasRecentActivity) {
            return <span className="status-badge active">Active</span>;
        }

        const hasAnyActivity = patient.lastJournalEntry;
        if (hasAnyActivity) {
            return <span className="status-badge inactive">Inactive</span>;
        }

        return <span className="status-badge new">New</span>;
    };

    if (loading) {
        return (
            <div className="patient-list-loading">
                <div className="loading-spinner"></div>
                <p>Loading patients...</p>
            </div>
        );
    }

    if (patients.length === 0) {
        return (
            <div className="patient-list-empty">
                <div className="empty-state">
                    <span className="empty-icon">👥</span>
                    <h3>No Patients Found</h3>
                    <p>No patients match your current search criteria.</p>
                    <button onClick={onRefresh} className="refresh-btn">
                        Refresh List
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="patient-list">
            <div className="patient-list-header">
                <h3>Patient List ({patients.length})</h3>
                <button onClick={onRefresh} className="refresh-btn small">
                    🔄 Refresh
                </button>
            </div>

            <div className="patient-grid">
                {patients.map((patient) => (
                    <div
                        key={patient.id}
                        className="patient-card"
                        onClick={() => onPatientSelect(patient)}
                    >
                        <div className="patient-card-header">
                            <div className="patient-avatar">
                                {patient.name.split(' ').map(n => n[0]).join('').toUpperCase()}
                            </div>
                            <div className="patient-info">
                                <h4>{patient.name}</h4>
                                <p className="patient-email">{patient.email}</p>
                                {getStatusBadge(patient)}
                            </div>
                        </div>

                        <div className="patient-stats">
                            <div className="stat-item">
                                <span className="stat-label">Progress</span>
                                <div className="progress-bar">
                                    <div
                                        className="progress-fill"
                                        style={{
                                            width: `${patient.journalProgress || 0}%`,
                                            backgroundColor: getProgressColor(patient.journalProgress || 0)
                                        }}
                                    ></div>
                                </div>
                                <span className="progress-text">{patient.journalProgress || 0}%</span>
                            </div>

                            <div className="patient-metrics">
                                <div className="metric">
                                    <span className="metric-label">Cycle</span>
                                    <span className="metric-value">{patient.currentCycleNumber || 1} <span className="metric-sub">({patient.completedCycles || 0} done)</span></span>
                                </div>
                                <div className="metric">
                                    <span className="metric-label">Last Entry</span>
                                    <span className="metric-value">{formatDate(patient.lastJournalEntry)}</span>
                                </div>
                                <div className="metric">
                                    <span className="metric-label">Total Entries</span>
                                    <span className="metric-value">{patient.totalEntries || 0}</span>
                                </div>
                            </div>
                        </div>

                        <div className="patient-card-footer">
                            <button className="view-btn">
                                View Details →
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PatientList;